import _curry from 'lodash/curry';
import _isEmpty from 'lodash/isEmpty';
import _negate from 'lodash/negate';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Utils
import getValuesFromById from '@tekion/tekion-base/utils/getValuesFromById';

/**
 * Checks whether the value is present in the cache.
 * Returns true if the value is present in the select cache.
 * @param {Object} cache: Cache in which we want to search values.
 * @param {String} value: Value string which needs to be checked for its presence in cache.
 */
var isValuePresent = _curry(function (cache, value) {
  return !!cache[value];
});

/**
 * Given a list of values returns a list of values which are not present in the cache and needs lookup
 * @param {Object} cache: Cache in which we want to search values.
 * @param {Array} values: List of value strings which need lookup.
 */
export var getValuesNotInCache = function getValuesNotInCache() {
  var cache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_ARRAY;
  return values.filter(_negate(isValuePresent(cache)));
};
export var getValuesFromCache = function getValuesFromCache(cache, ids) {
  var values = getValuesFromById(cache, ids);
  if (_isEmpty(values)) {
    return ids;
  }
  return values;
};